import React, { useEffect, useState } from "react";
import CustomPopup from "./CustomPopup";
import ImageSubstitute from "./ImageSubstitute";

const ViewProfilePopup = ({
  show,
  details,
  onClose,
  heading,
  id,
  onRequestDetails,
  isAccepted,
  requestStatus,
}) => {
  const [isRequestSent, setIsRequestSent] = useState(false);

  useEffect(() => {
    if (!show) {
      setIsRequestSent(false);
    }
    // If we have a status, update the request sent state
    if (requestStatus) {
      setIsRequestSent(requestStatus !== "Rejected");
    }
  }, [show, requestStatus]);

  const handleClick = async () => {
    await onRequestDetails();
    setIsRequestSent(true);
  };

  // Determine button state and text
  const getButtonState = () => {
    switch (requestStatus) {
      case "Approved":
        return {
          text: "Request Approved",
          disabled: true,
          className: "btn-success",
          message: "You can view all contact details",
          showFullDetails: true,
        };
      case "Rejected":
        return {
          text: "Sent Request",
          disabled: false,
          className: "btn-primary",
          message: "Your previous request was rejected. You can try again.",
          showFullDetails: false,
        };
      case "Pending":
        return {
          text: "Request Pending",
          disabled: true,
          className: "btn-warning",
          message: "Waiting for approval",
          showFullDetails: false,
        };
      default:
        return isRequestSent
          ? {
              text: "Request Sent",
              disabled: true,
              className: "btn-secondary",
              message: "Your request has been submitted",
              showFullDetails: false,
            }
          : {
              text: "Sent Request",
              disabled: false,
              className: "btn-primary",
              message: "Request to view full profile",
              showFullDetails: false,
            };
    }
  };

  const buttonState = getButtonState();

  return (
    <CustomPopup
      className="modal-lg"
      showModal={show}
      closeModal={onClose}
      heading={heading}
    >
      <div className="view-member-profile-detail">
        <div
          className="profile-img"
          style={{
            width: "200px",
          }}
        >
          {details.DisplayURL &&
          details.DisplayURL !== `${process.env.REACT_APP_API_URL}/` ? (
            <img src={details?.DisplayURL} alt="" />
          ) : (
            <ImageSubstitute name={details?.FirstName} />
          )}
        </div>
        <ul className="view-profile-list">
          <li>
            <strong>Name: </strong>{" "}
            <span>{details.FirstName ?? "" + details?.LastName ?? ""} </span>
          </li>
          <li>
            <strong>Gender: </strong> <span>{details.Gender ?? "N/A"}</span>
          </li>
          <li>
            <strong>Email: </strong> <span>{details.Email ?? ""}</span>
          </li>
          <li>
            <strong>City: </strong> <span>{details?.CityName ?? "N/A"}</span>
          </li>
          <li>
            <strong>State: </strong> <span>{details?.State ?? "N/A"}</span>
          </li>

          {buttonState.showFullDetails && (
            <>
              <li>
                <strong>FatherName: </strong>{" "}
                <span>{details?.FatherName ?? "N/A"}</span>
              </li>
              <li>
                <strong>DOB: </strong> <span>{details?.DOB ?? "N/A"}</span>
              </li>
              <li>
                <strong>AddressLine1: </strong>{" "}
                <span>{details?.AddressLine1 ?? "N/A"}</span>
              </li>
              <li>
                <strong>CityName: </strong>{" "}
                <span>{details?.CityName ?? "N/A"}</span>
              </li>
              <li>
                <strong>Pincode: </strong>{" "}
                <span>{details?.Pincode ?? "N/A"}</span>
              </li>
              <li>
                <strong>PhoneNumber: </strong>{" "}
                <span>{details?.PhoneNumber ?? "N/A"}</span>
              </li>
              <li>
                <strong>SubCaste: </strong>{" "}
                <span>{details?.SubCaste ?? "N/A"}</span>
              </li>
              <li>
                <strong>Height: </strong>{" "}
                <span>{details?.Height ?? "N/A"}</span>
              </li>
              <li>
                <strong>Weight: </strong>{" "}
                <span>{details?.Weight ?? "N/A"}</span>
              </li>
              <li>
                <strong>Number Of Brother: </strong>{" "}
                <span>{details?.NumberOfBrother ?? "N/A"}</span>
              </li>
              <li>
                <strong>Number Of Sister: </strong>{" "}
                <span>{details?.NumberOfSister ?? "N/A"}</span>
              </li>
              <li>
                <strong>Religion: </strong>{" "}
                <span>{details?.Religion ?? "N/A"}</span>
              </li>
              <li>
                <strong>Category: </strong>{" "}
                <span>{details?.Category ?? "N/A"}</span>
              </li>
              <li>
                <strong>BodyType: </strong>{" "}
                <span>{details?.BodyType ?? "N/A"}</span>
              </li>
              <li>
                <strong>SkinColor: </strong>{" "}
                <span>{details?.SkinColor ?? "N/A"}</span>
              </li>
              <li>
                <strong>Occupation: </strong>{" "}
                <span>{details?.Occupation ?? "N/A"}</span>
              </li>
              <li>
                <strong>Annual Income: </strong>{" "}
                <span>{details?.AnnualIncome ?? "N/A"}</span>
              </li>
              <li>
                <strong>Father Occupation: </strong>{" "}
                <span>{details?.FatherOccupation ?? "N/A"}</span>
              </li>
              <li>
                <strong>Mother Occupation: </strong>{" "}
                <span>{details?.MotherOccupation ?? "N/A"}</span>
              </li>
              <li>
                <strong>Mother Tounge: </strong>{" "}
                <span>{details?.MotherTounge ?? "N/A"}</span>
              </li>
              <li>
                <strong>Profile CatName: </strong>{" "}
                <span>{details?.ProfileCatName ?? "N/A"}</span>
              </li>
              <li>
                <strong>Nationality: </strong>{" "}
                <span>{details?.Nationality ?? "N/A"}</span>
              </li>
              <li>
                <strong>DistrictName: </strong>{" "}
                <span>{details?.DistrictName ?? "N/A"}</span>
              </li>
            </>
          )}
        </ul>
        <div className="text-end mt-3">
          <button
            className={`btn ${buttonState.className}`}
            onClick={handleClick}
            disabled={buttonState.disabled}
          >
            {buttonState.text}
          </button>
          {buttonState.message && (
            <div
              className={`mt-2 small text-${
                requestStatus === "Rejected"
                  ? "danger"
                  : requestStatus === "Approved"
                  ? "success"
                  : requestStatus === "Pending"
                  ? "warning"
                  : "muted"
              }`}
            >
              {buttonState.message}
            </div>
          )}
        </div>
      </div>
    </CustomPopup>
  );
};

export default ViewProfilePopup;
